import { PlayerConfig } from "../../Config";
export class WorkerLoader {
    static workerSupported() {
        return Worker ? true : false;
    }
    static get enable() {
        return WorkerLoader._enable;
    }
    static set enable(value) {
        if (WorkerLoader._enable != value) {
            if (value) {
                if (!Worker)
                    return;
                if (!WorkerLoader._worker) {
                    WorkerLoader._worker = new Worker(PlayerConfig.workerLoaderLib || WorkerLoader.workerPath);
                    WorkerLoader._worker.onmessage = WorkerLoader.workerMessage;
                }
            }
            WorkerLoader._enable = value;
        }
    }
    static load(url, options) {
        try {
            url = new URL(url, document.baseURI).href;
        }
        catch (e) {
        }
        let callbacks = WorkerLoader._queue[url];
        if (callbacks) {
            return new Promise((resolve, reject) => {
                callbacks.push(resolve, reject);
            });
        }
        else {
            WorkerLoader._queue[url] = callbacks = [];
            return new Promise((resolve, reject) => {
                callbacks.push(resolve, reject);
                WorkerLoader._worker.postMessage({ url, options });
            });
        }
    }
    static workerMessage(evt) {
        let data = evt.data;
        if (data) {
            switch (data.type) {
                case "Image":
                    let callbacks = WorkerLoader._queue[data.url];
                    if (callbacks) {
                        delete WorkerLoader._queue[data.url];
                        let param = data.imageBitmap ? data.imageBitmap : data.msg;
                        for (let i = data.imageBitmap ? 0 : 1; i < callbacks.length; i += 2) {
                            callbacks[i](param);
                        }
                    }
                    break;
            }
        }
    }
}
WorkerLoader.workerPath = "libs/laya.workerloader.js";
WorkerLoader._enable = false;
WorkerLoader._queue = {};
